export default "__VITE_ASSET__BerCzl2q__"